export enum VideoBlockType {
  Iframe = 'iframe',
  Video = 'video',
}
